import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CheckUserNameBySmsTokenForLoginAccountUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(name: string): Promise<SATResult<void, SATError>> {
    return this.appAccountSettingRepo.checkUserNameBySmsTokenForLoginAccount(name);
  }
}
